import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import CartIcon from 'mdi-react/CartIcon';

const DomainOffer = ({ t, offer, onReserve}) => (
    <div>
        <div className="row domain-offer" >
            <div className="col-sm-6 domain-offer_domain">
                { offer.premium && <div className="domain-offer_premium-tag">PREMIUM</div>}
                <span className="domain-offer_domain-name">{offer.sld}<strong>.{offer.tld}</strong></span>
            </div>
            <div className="col-sm-5 pull-right text-right">
                <span className="domain-offer_price-hive">{offer.purchasePrice.hive} HIVE</span> <strong>/</strong> <span className="domain-offer_price-hbd">{offer.purchasePrice.hbd} HBD</span>
                <br/>
                <span className="domain-offer_renewal" title={t('domains.find_domains.renewal_tooltip')}>{t('domains.find_domains.renewal')}: {offer.renewalPrice.hive} HIVE / {offer.renewalPrice.hbd} HBD</span>
            </div>
            <div className="col-sm-1 pull-right text-right domain-offer_reserve">
                <button
                    className="cart__table-btn"
                    type="button"
                    onClick={onReserve}
                    title={t('domains.find_domains.reserve_tooltip')}
                ><CartIcon /> {t('domains.find_domains.reserve')}</button>
            </div>
        </div>
    </div>
);

DomainOffer.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation('dashboard')(DomainOffer);
